import { render, staticRenderFns } from "./ThemplateMedicalRecord.vue?vue&type=template&id=000be777&"
import script from "./ThemplateMedicalRecord.vue?vue&type=script&lang=js&"
export * from "./ThemplateMedicalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports